import { createFileRoute, redirect } from "@tanstack/react-router";

/** Alte Landingpage der Vorgängerseite, dauerhaft auf die Startseite. */
export const Route = createFileRoute("/landing.html")({
  beforeLoad: () => {
    throw redirect({ href: "/", statusCode: 301 });
  },
  component: () => null,
});
